import { Injectable } from '@angular/core';
import { catchError, forkJoin, map, Observable, of, throwError } from 'rxjs';
import { InfoCategory } from '../../shared/models/app/info-category';
import { Product } from '../../shared/models/product/product';
import { AppInfoService } from '../app-info/app-info.service';
import { HttpService } from '../http/http.service';
import { DashboardProductBestSellingFilter } from './../../shared/models/dashboard/dashboard-product-best-selling-filter';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  public _categorires: InfoCategory[] = [];

  constructor(
    private appInfoService: AppInfoService,
    private httpService: HttpService
  ) {}

  public bestSellingProducts(
    filter: DashboardProductBestSellingFilter
  ): Observable<Array<Product>> {
    return forkJoin({
      res: this.httpService.post(`dashboard/best-selling-products/`, filter),
      categories: of(this.getCategories()),
    }).pipe(
      map(({ res, categories }) => {
        let response: Product[] = [];

        if (res) {
          response = res.map((productBanco: any) => {
            const newProduct = new Product();
            newProduct.fromJson(productBanco, categories);
            return newProduct;
          });
        }

        return response;
      }),
      catchError((error: any) => {
        const msg =
          error?.error?.message ||
          error?.error?.error ||
          'Ocorreu um erro ao buscar os produtos.';
        return throwError(() => new Error(msg));
      })
    );
  }

  getCategories() {
    if (this._categorires?.length > 0) {
      return this._categorires;
    } else {
      this._categorires = this.appInfoService.getCategories();
      return this._categorires;
    }
  }
}
